<template>
  <div class="app-avatar_aar">

    <input-title :required="options.required" :description="options.description"/>

    <div class="input-groups">

      <div class="error-message" v-if="isLoading && showLoadingError">
        {{ validateMessages.isLoading }}
      </div>

      <div
        v-for="(v, i) in valueLocal"
        :key="`app-file-input-group-${i}`"
        class="input-group"
        @click="removeError(i)">

        <el-upload
          v-show="!v"
          class="aar_upload"
          :ref="`app-avatar-upload-${i}`"
          :limit="1"
          :show-file-list="false"
          accept="jpg"
          :before-upload="beforeUpload"
          :headers="headers"
          :action="`${apiUrl}users/avatar/${userId}`"
          :on-progress="onProgress"
          :on-change="loadingStopped"
          :before-remove="beforeRemove"
          :on-success="onSuccess">
          <el-button size="small" slot="trigger">Загрузить файл</el-button>
          <div class="aar_upload-tip" slot="tip">
            Допускаются файлы jpg, размером до 2 мегабайт.</div>
        </el-upload>

        <img :src="v" class="aar_avatar">
        <el-button v-if="v" size="small" class="aar_del-btn" @click="deleteFile">
          Удалить изображение</el-button>

        <div v-if="error[i]" class="ait_message ait_message--error">
          {{ error[i] }}</div>

      </div>

    </div>

    <add-rem-btns/>

  </div>
</template>

<script>
import axios from 'axios';
import approve from 'approvejs';
import Common from './mixins/Common';

export default {

  mixins: [Common],

  data() {
    return {
      valueBase: '',
      isLoading: false,
      showLoadingError: false,
      errorBase: '',
      validateMessages: {
        required: 'Загрузите файл.',
        isLoading: 'Дождитесь завершения загрузки файлов.',
      },
    };
  },

  computed: {

    headers() {
      const token = this.$store.getters['user/getAuthToken'];
      const headers = {};
      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }
      return headers;
    },

    userId() {
      return this.$store.getters['user/getUserId'];
    },

    apiUrl() {
      return this.$store.state.apiUrl;
    },

  },

  mounted() {
    this.fetchAvatarImage();
  },

  methods: {

    beforeUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$refs['app-avatar-upload-0'][0].clearFiles();
        this.$notify.error('Изображение должно иметь расширение jpg.');
      }
      if (!isLt2M) {
        this.$refs['app-avatar-upload-0'][0].clearFiles();
        this.$notify.error('Размер изображения не должен превышать 2 мегабайта.');
      }
      return isJPG && isLt2M;
    },

    deleteFile() {
      axios.delete(`users/avatar/${this.userId}`).then(() => {
        this.valueLocal[0] = this.valueBase;
        this.$refs['app-avatar-upload-0'][0].clearFiles();
        this.$forceUpdate();
      }).catch(() => this.$notify.error('Ошибка при удалении.'));
    },

    getIndexByFile(file) {
      let index = -1;
      Object.keys(this.$refs).forEach((refKey, refIndex) => {
        if (this.$refs[refKey].length && this.$refs[refKey][0].uploadFiles.length) {
          const refResponse = this.$refs[refKey][0].uploadFiles[0].response;
          if (refResponse === file.response) {
            index = refIndex;
          }
        }
      });
      return index;
    },

    beforeRemove(file) {
      this.loadingStopped();
      const i = this.getIndexByFile(file);
      this.valueLocal[i] = Object.assign({}, this.valueBase);
      this.error[i] = this.errorBase;
    },

    onSuccess() {
      this.loadingStopped();
      this.fetchAvatarImage();
    },

    fetchAvatarImage() {
      axios.get(`users/avatar/${this.userId}`).then((r) => {
        if (r.data) {
          this.valueLocal[0] = `${this.apiUrl}${r.data}?_=${Math.random()}`;
          this.updateValue();
        }
      }).catch(() => this.$notify.error('Ошибка при запросе изображения для аватара.'));
    },

    loadingStopped() {
      this.isLoading = false;
      this.showLoadingError = false;
    },

    onProgress() {
      this.isLoading = true;
    },

    getError() {
      // Validate isLoading
      if (this.isLoading) {
        this.showLoadingError = true;
        return [this.validateMessages.isLoading];
      }
      // Validate required
      if (this.options.required) {
        this.valueLocal.forEach((value, i) => {
          const result = approve.value(value, { required: true });
          this.error[i] = result.approved ? '' : this.validateMessages.required;
        });
      }
      this.updateValue();
      return this.error;
    },

  },

};
</script>

<style lang="scss">
@import '../../../styles/common/main';

.app-avatar_aar {
  .aar_upload {
    text-align: center;
  }
  .aar_upload-tip {
    color: #b2b2b2;
    font-size: 14px;
    margin: 15px 0 0 1px;
  }
  .el-button.el-button--default.el-button--small {
    @include border-radius;
    background: transparent;
    color: #fff;
    border: 1px solid #d85486;
    @include transition;
    &:hover {
      background: #d85486;
    }
  }
  .aar_avatar {
    display: block;
    margin: 0 auto 20px;
    @include border-radius(4px);
    height: auto;
    max-width: 100%;
    -webkit-mask-image: url(../../../../static/grx/hexagon-white.svg);
    mask-image: url(../../../../static/grx/hexagon-white.svg);
  }
  .aar_del-btn {
    width: 150px;
    display: block;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/inputs/widgets/AppAvatar.vue